import { useCallback } from 'react'
import {
  TextInput,
  ReferenceInput,
} from 'react-admin'
import { Box } from '@material-ui/core'
import { Autocomplete } from '../../custom'
import {
  referenceInputOptions,
  formInputOptions,
} from '../../util/component-options'
import { relationships } from '../../../data-model'
import { useFormStyles } from '../../../styles'
import { useLabel } from '../../../hooks'
import { Form, getValidator } from '../../form'

const BrokerDriversUsersForm = props => {
  const { resource, record } = props
  const formClasses = useFormStyles(props)
  const label = useLabel(props)
  const resourceRelationships = relationships[resource]
  const recordId = record.id
  const isNewRecord = !recordId

  const transform = useCallback(data => {
    const result = {
      id: data.id,
      broker_driver_id: data.broker_driver.id,
    }

    if (isNewRecord) {
      result.user_attributes = {
        email: data.user.email,
      }
    }

    return result
  }, [isNewRecord])


  return (
    <Form
      {...props}
      transform={transform}
    >
      <Box className={formClasses.grid}>
        <Box>
          <TextInput
            {...formInputOptions}
            source='user.email'
            label={label('user.email')}
            validate={getValidator()}
            disabled={!isNewRecord}
            required
          />

          {
            !isNewRecord && record.user.temp_password &&
            <TextInput
              {...formInputOptions}
              source='user.temp_password'
              label={label('user.temp_password')}
              disabled
            />
          }

          <ReferenceInput
            {...referenceInputOptions(resourceRelationships['broker_driver'])}
            {...formInputOptions}
            source='broker_driver.id'
            reference={resourceRelationships['broker_driver']}
            label={label('broker_driver.name')}
          >
            <Autocomplete
              validate={getValidator()}
              required
            />
          </ReferenceInput>
        </Box>
      </Box>
    </Form>
  )
}

export default BrokerDriversUsersForm
